const deleteUser = () => {};

export default deleteUser;
